import { useFormContext } from "react-hook-form";
import { formatDateMmDdYyyy } from "../../helpers/dateHelper";
import { SHIPPING } from "../../constants";

export const getPurchaseOrderDetails = (data = {}) => {
  const { watch } = useFormContext();
  const formData = watch();

  const order = data?.orders?.length ? data?.orders[0] : {};

  return {
    ...data,
    templateId: formData?.templateId,
    shipVia: SHIPPING?.find((s) => s.id === order?.shipVia)?.label,
    boxes: formData.boxes,
    weight: formData.weight,
    checkedBy: formData.checkedBy,
    items: formData.items,
  };
};

export const barcodeMapper = (data) => ({
  name: data?.name,
  top: data?.top || [],
  bottom: data?.bottom || [],
  delimiter: data?.delimiter,
  format: data?.format,
  label: !!data?.label,
  object: Number(data?.object),
  serialize: !!data?.serialize,
  size: Number(data?.size),
  barcode: data?.barcode?.map((field, idx) => ({
    field: field?.field,
    format: field?.format,
    padding: Number(field?.padding || 0),
    order: idx,
  })),
});

export const getFileName = (data) => {
  const order = data?.orders?.length ? data?.orders[0] : {};
  const customer = order?.customer?.name?.replace(/\s+/g, "_");
  const date = formatDateMmDdYyyy(data?.createdAt)?.replace(/\//g, "");
  const number = data?.id;
  const name = `${customer}_Pslip_${date}_${number}_F`;
  return name;
};

